<style src="./style.scss">
</style>

<script lang="ts">
  import { afterUpdate, onMount } from "svelte";

  import Icon from "svelte-icon";

  import Button from "@components/button";
  import Badge from "@components/badge";
  import Header from "@components/header";
  import Footer from "@components/footer";
  import Spinner from "@components/spinner";
  import Card from "@components/card";
  import Sidebar from "@components/sidebar";
  import Toast from "@components/toast";
  import { navigate, useLocation } from "svelte-navigator";
  import { SUBSCRIPTION_QUERY } from "./subscription.query.ts";
  import { query, mutation } from "svelte-apollo";
  import { formatCurrency } from "@utils";
  import { getEmail, removeToken, getToken } from "@services/auth";
  import {
    AmericamExpressCardIcon,
    AuraCardIcon,
    DinersCardIcon,
    DiscoverCardIcon,
    EloCardIcon,
    HiperCardCardIcon,
    HiperCardIcon,
    MasterCardIcon,
    VisaCardIcon,
  } from "@assets/icons/cards";

  export let isLoading = true;

  let subscription;
  let status = {};
  let showToastMessage = false;
  let toastMessage = "";
  const email = getEmail();

  const subscriptionQuery = query(SUBSCRIPTION_QUERY);

  const token = getToken();
  const location = useLocation();

  if (!token) {
    navigate("/");
  }

  afterUpdate(() => {
    if ($subscriptionQuery?.data?.subscription !== null) {
      subscription = $subscriptionQuery?.data?.subscription;

      if (subscription?.id === null) {
        removeToken();
        navigate("/");
        return;
      }

      status = getPayemntStatus(subscription?.status);

      isLoading = false;
    }
  });

  onMount(() => {
    if ($location?.state?.showToast) {
      showToastMessage = true;
      toastMessage = $location.state.message;

      navigate("/overview", { replace: true, state: {} });
    }
  });

  const getProducColor = () =>
    subscription.productName === "Plano Gold" ? "#FFAE00" : "#CCD6E5";

  function getCreditCardBrandIcon(brand) {
    let brandIcon;

    switch (brand) {
      case "VISA":
        brandIcon = VisaCardIcon;
        break;
      case "DINERS":
        brandIcon = DinersCardIcon;
        break;
      case "ELO":
        brandIcon = EloCardIcon;
        break;
      case "DISCOVER":
        brandIcon = DiscoverCardIcon;
        break;
      case "HIPERCARD":
        brandIcon = HiperCardIcon;
        break;
      case "AMEX":
        brandIcon = AmericamExpressCardIcon;
        break;
      case "AURA":
        brandIcon = AuraCardIcon;
        break;
      case "MASTERCARD":
        brandIcon = MasterCardIcon;
        break;
    }

    return brandIcon;
  }

  function goUpdateCredCradScreen() {
    navigate("/payment", { state: subscription });
  }

  function getPayemntStatus(statusName) {
    let status;

    switch (statusName) {
      case "PAID":
        status = {
          text: "Ativo",
          color: "#d1f8b8",
        };
        break;
      case "ACTIVE":
        status = {
          text: "Ativo",
          color: "#d1f8b8",
        };
        break;
      case "PAYMENT_PENDING":
        status = {
          text: "Pendente",
          color: "#FFAA97",
        };
        break;
      case "CANCELED":
        status = {
          text: "Cancelado",
          color: "#e4e4e4",
        };
      case "REFUNDED":
        status = {
          text: "Cancelado",
          color: "#e4e4e4",
        };
        break;
    }

    return status;
  }

  function isCanceled() {
    return (
      subscription.status === "CANCELED" || subscription.status === "REFUNDED"
    );
  }
</script>

{#if isLoading || !subscription}
  <Spinner />
{:else}
  <div class="overview">
    <div>
      <div
        class="{`overview__content ${
          showToastMessage ? 'toast-content' : ''
        }`}">
        <div class="success-toast">
          <Toast
            message="{toastMessage}"
            toastType="info"
            visible="{showToastMessage}"
            onClose="{() => (showToastMessage = false)}" />
        </div>

        <div class="overview__content__panel">
          <h1>Visão geral</h1>
          <h2>Informações do perfil</h2>

          <div>
            <div class="overview-info">
              <div>E-mail</div>
              <div>{email}</div>
            </div>
          </div>
        </div>

        <div class="overview__content__panel">
          <Card
            ><div>
              <div class="subscription-plan">
                <Badge
                  title="{subscription.productName}"
                  background="{getProducColor()}" />
                <Badge title="{status?.text}" background="{status?.color}" />
              </div>

              {#if subscription.cardNumber}
                <h2>Pagamento</h2>
              {/if}

              {#if subscription.cardBrand && !isCanceled()}
                <div class="payment-info">
                  <p>
                    Sua próxima cobrança será no dia <b
                      >{new Date(
                        subscription?.nextPaymentDate
                      ).toLocaleDateString("pt-br")}</b
                    >, no valor de
                    <b>R$ {formatCurrency(subscription.amount)}.</b>
                  </p>
                </div>
              {/if}
              {#if !subscription.cardNumber || isCanceled()}
                <div class="payment-info">
                  {#if subscription.endAt}
                    <p>
                      Sua assinatura encerrará dia <b>
                        {new Date(subscription?.endAt).toLocaleDateString(
                          "pt-br"
                        )}
                      </b>
                    </p>
                  {/if}
                </div>
              {/if}
              {#if subscription.cardBrand && !isCanceled()}
                <div class="card-info">
                  <Icon
                    data="{getCreditCardBrandIcon(subscription.cardBrand)}"
                    size="39px"
                    stroke="transparent"
                    fill="#FFFFFF" />
                  <div>
                    <div>
                      {subscription.cardBrand} •••• •••• •••• {subscription.cardNumber}
                    </div>
                    <div>{subscription.cardExpirationDate}</div>
                  </div>
                </div>
                {#if !isCanceled()}
                  <Button
                    title="Atualizar"
                    onClick="{goUpdateCredCradScreen}"
                    type="secondary" />
                {/if}
              {/if}
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
{/if}
